jQuery(function () {
  var toggleAll = "[data-behaviour~=select-all-records]";
  var toggle = "[data-behaviour~=select-record]";

  var selectedEvent = "record:selected";
  var unselectedEvent = "record:unselected";

  // BEHAVIOUR
  jQuery(document).on("change", toggleAll, toggleSelectAll);
  jQuery(document).on("change", toggle, toggleChangeHandler);

  // HELPER FUNCTIONS

  function toggleSelectAll(event) {
    event.preventDefault();
    if (jQuery(this).is(".selected")) {
      updateToggleClass(this, false);
      jQuery(toggle).find(":checkbox:checked").prop("checked", false).trigger("change");
    } else {
      updateToggleClass(this, true);
      jQuery(toggle).find(":checkbox:not(:checked)").prop("checked", true).trigger("change");
    }
  }

  function toggleChangeHandler(event) {
    const $toggle = jQuery(this);
    var selected = isSelected(event);

    updateToggleClass($toggle, selected);

    var payload = {
      element: this,
      recordClass: $toggle.data("record-class"),
      recordId: $toggle.data("record-id"),
      selected: selected,
    };

    $toggle.trigger(selected ? selectedEvent : unselectedEvent, [payload]);
  }

  function isSelected(event) {
    return jQuery(event.target).is(":checked");
  }

  function updateToggleClass(toggle, selected) {
    if (selected) {
      jQuery(toggle).addClass("selected");
    } else {
      jQuery(toggle).removeClass("selected");
    }
  }

  // INITIALIZE

  jQuery(toggle).filter(":checked").trigger("change");
  jQuery(toggle).find(":checked").trigger("change");
});
